export const TIPI_SCHEDA = ["Nuovo contatto", "Aggiornamento anagrafica"];
export const REPARTI = ["Direzione", "Segreteria", "Amministrazione", "Commerciale", "Ordini", "Magazzino"];
export const TIPOLOGIE_CLIENTE = ["Azienda", "Ditta individuale", "Privato", "Altro"];

const today = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const emptyCliente = () => ({
  tipo_scheda: "", data_inserimento: today(),
  ragione_sociale: "", insegna: "", tipologia_cliente: "", partita_iva: "", codice_fiscale: "",
  codice_sdi: "", pec: "", settore: "", sito_web: "",
  referenti: [], email_amministrazione: "",
  sede_via: "", sede_cap: "", sede_citta: "", sede_provincia: "",
  consegna_via: "", consegna_cap: "", consegna_citta: "", consegna_provincia: "",
  consegna_referente: "", consegna_telefono: "", consegna_orari: "",
  fatturazione_via: "", fatturazione_cap: "", fatturazione_citta: "", fatturazione_provincia: "",
  note: "", data_aggiornamento: "", card_photo: null,
  consenso_privacy: false, consenso_tracking_email: false,
});

export const emptyReferente = (reparto) => ({ reparto, nome: "", ruolo: "", telefono: "", cellulare: "", email: "" });

// Dati referente riconosciuti da QR/OCR (formato buyer)
export const captureToReferente = (d) => {
  const map = { nome_buyer: "nome", ruolo: "ruolo", email: "email", cellulare: "cellulare" };
  return Object.fromEntries(Object.entries(d).filter(([k, v]) => map[k] && v).map(([k, v]) => [map[k], v]));
};

export const validateCliente = (f, requirePrivacy = true) => {
  if (!f.tipo_scheda) return "Seleziona se è un Nuovo contatto o un Aggiornamento anagrafica";
  if (!f.referenti?.length) return "Seleziona almeno un reparto referente";
  if (!f.ragione_sociale && !f.referenti.some((r) => r.nome)) return "Inserisci almeno Ragione sociale o il nome di un referente";
  if (requirePrivacy && !f.consenso_privacy) return "Per salvare è necessario il consenso privacy";
  return null;
};
